App.EventTable = class extends App.DataTable {
  constructor(table) {
    const dataSourceUrl = "/events/data_table";

    const columns = [
      {
        name: "edit",
        width: "60px",
        visible: false,
        sortable: false,
        render: function (data, type, full, meta) {
          var editLink = "/events/" + full.id + "/edit";
          return (
            '<a href="' +
            editLink +
            '" class="btn btn-xs btn-muted-blue" >Edit</a>'
          );
        },
      },
      {
        data: "date",
        width: "53px",
        className: "all",
      },
      {
        data: "title",
        className: "all",
        width: "180px",
        render: function (data, type, full, meta) {
          return `${full.title} (ID: ${full.id})`;
        },
      },
      {
        data: "event_type",
        width: "91px",
        className: "all",
      },
      {
        data: "status",
        width: "40px",
        className: "all text-center",
      },
      {
        data: "rsvps",
        width: "85px",
        className: "all text-center",
        sortable: false,
      },
      {
        data: "owner",
        width: "91px",
        className: "all",
      },
      {
        data: "presenters",
        width: "81px",
        className: "all",
      },
      {
        name: "email",
        width: "109px",
        data: "email",
        className: "all",
        sortable: false,
        visible: false,
      },
    ];

    var searchFilterHtml = {
      "filter-id":
        '<input type="text" class="form-control input-sm filter-text" ' +
        'placeholder="ID" ' +
        'name="filter-id-input" ' +
        'style="min-width: 34px" />',
      "filter-date":
        '<input type="text" class="form-control input-sm filter-text" ' +
        'placeholder="mm/dd/yyyy" ' +
        'name="filter-date-input" ' +
        'id="filter-date-input" />',
      "filter-event_type": ((eventtypes) => {
        return [
          '<select class="form-control input-sm">',
          '<option selected="selected" value="">Any</option>',
          ...eventtypes.map((e) => {
            return `<option value="${e.id}">${e.name.humanize()}</option>`;
          }),
          "</select>",
        ].join("");
      })($("#filter-event_type").data("types")),
    };

    super({
      table: table,
      dataSourceUrl: dataSourceUrl,
      columns: columns,
      searchFilterHtml: searchFilterHtml,
      initialOrder: [[1, "desc"]],
      autoWidth: false
    });
  }

  /**
   * Initialize the datatable to only display the events with a Status column of "Enabled"
   */
  setupInitialTable() {
    // Execute the filter only if the column in the table has a class of "select-filter"
    if ($("#filter-status").hasClass("select-filter")) {
      $("#event_list")
        .DataTable()
        .column("status:name")
        .search("Enabled")
        .draw();
    }
  }

  afterDataLoad(e, settings, json, xhr) {
    if (json.current_user.can_edit_event) {
      $("#event_list").DataTable().column("edit:name").visible(true);
      $("#event_list").DataTable().column("email:name").visible(true);
    }
  }

  /**
   * Initialize the datatable to query the server for data with the columns in order
   */
  setupTableEvents() {
    /**
     * Search member list by permissions
     */
    var searchPermissions = function () {
      var permissionFields = $(
        "#permissions_search_container select, #permissions_search_container input"
      );
      var permissionParams = "?" + permissionFields.serialize();

      // reload datatable with new params
      $("#event_list").DataTable().ajax.url(permissionParams).load();

      return false;
    };

    // Add events to table rows
    // this.table.find('tbody').on('click', 'tr', clickRow.bind(this));

    // Add events to permission search
    $("button#search_permissions").on("click", searchPermissions);

    this.table.on("xhr.dt", this.afterDataLoad.bind(this));
  }
};

$(document).on("turbo:load", function () {
  if ($(".events.index").length == 0) return;
  var userTable = new App.EventTable($("#event_list"));
  userTable.render();
  userTable.setupInitialTable();
  userTable.setupTableEvents();
});
